module.exports = __webpack_public_path__ + "img/gyg.1c3a3d6c.png";